const o = "Champ couleur, la couleur actuelle est le {color}", e = "Color field", l = "Colors palette", r = "Couleurs prédéfinies", s = "Custom preset colors", c = "Add color", t = "Supprimer la couleur", u = "Custom color, HEX format", C = "Ajouter une couleur à la liste des couleurs personnalisées", a = "Vider le champ couleurs personnalisées", n = "Delete color with backspace", d = {
  currentColor: o,
  emptyColor: e,
  palette: l,
  presetColors: r,
  customColors: s,
  addColor: c,
  clearColor: t,
  colorField: u,
  colorFieldConfirm: C,
  colorFieldClear: a,
  deleteColorDescriber: n
};
export {
  c as addColor,
  t as clearColor,
  u as colorField,
  a as colorFieldClear,
  C as colorFieldConfirm,
  o as currentColor,
  s as customColors,
  d as default,
  n as deleteColorDescriber,
  e as emptyColor,
  l as palette,
  r as presetColors
};
